// Archivo home
//
import React from 'react';
import { Container, Typography } from '@mui/material';

const Home = () => {
  return (
    <Container>
      <Typography variant="h2" component="h1" gutterBottom>
        Bienvenido al CRM
      </Typography>
      <Typography variant="body1">
        Esta es la página de inicio de tu aplicación CRM.
      </Typography>
    </Container>
  );
};

export default Home;
